import createApiClient from "./api";
import API_BASE_URL from "../utils/apiConfig";

const api = createApiClient();

export const fetchSharedFolder = async (kind, shareToken, folderId = null) => {
  const response = await api.get(`/public/shares/${kind}/${shareToken}`, {
    params: folderId ? { folder_id: folderId } : {},
  });
  return response.data;
};

export const getSharedFileUrl = (kind, shareToken, fileId, download = false) =>
  `${API_BASE_URL}/public/shares/${kind}/${shareToken}/files/${encodeURIComponent(fileId)}${
    download ? "?download=true" : ""
  }`;
